export default function Header() {
    return (
        <div className="header">
            <h1>Jacinth Boggess</h1>
            <div className="classy-line"></div>
            <div className="nav-bar">
                <a href="https://www.linkedin.com/in/jacinth-boggess" target="_blank" rel="noopener noreferrer"><div>LinkedIn</div></a> | 
                <a href="https://github.com/Flowers70" target="_blank" rel="noopener noreferrer"><div>GitHub</div></a>
            </div>
        </div>
    )
}